module.exports = __webpack_public_path__ + "static/img/z.9981be8f.png";